import React from 'react';
import { DeviceSoloIcon } from '../../../../../theme/icons';
import {
  Box,
  CardContent,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { Merchandiser } from '../../../redux/composableDevice/model/Merchandiser.model';
import { getPolyglot } from '../../../../../i18n';
import ChannelConnection from '../../MerchandiserDetailPage/Channel/ChannelConnection';

export const DeviceDetail = (props: { merchandiser: Merchandiser }) => {
  const theme = useTheme();
  const polyglot = getPolyglot();
  const { merchandiser } = props;

  const filteredChannels =
    merchandiser?.channels.filter(
      (channel) =>
        channel?.channelType === 'action' || channel?.channelType === 'event'
    ) || [];

  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const image =
    merchandiser.iconURL ?? merchandiser.composableDevice?.labels?.imageURL;

  return (
    <CardContent
      sx={{
        borderRadius: '2rem',
        background: theme.palette.common.white,
        padding: 0,
        '&:last-child': { pb: 0 },
      }}
    >
      <Box
        textAlign={'center'}
        color={theme.palette.common.white}
        sx={{
          backgroundColor: theme.palette.secondary.dark,
          borderRadius: '2rem 2rem 0 0',
          padding: '0.5rem 0',
        }}
      >
        {polyglot.t('nuttall.flexeserve.status').toUpperCase()}
      </Box>
      <Stack display={'grid'} gap={1} sx={{ padding: '1rem' }}>
        <Box
          width={'100%'}
          sx={{
            background: theme.palette.common.white,
            padding: isTablet ? '0 1rem' : '0 5rem',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            minHeight: '350px',
            maxHeight: '350px',
          }}
        >
          {image ? (
            <img
              src={image}
              alt="Merchandiser Icon"
              style={{
                width: '100%',
                height: 'auto',
                maxHeight: '350px',
                objectFit: 'contain',
              }}
            />
          ) : (
            <DeviceSoloIcon width={'100%'} height={'100%'} />
          )}
        </Box>
        <Box sx={{ padding: '1rem' }}>
          <Typography
            variant="h5"
            component="div"
            color={theme.palette.common.black}
            sx={{ wordBreak: 'break-word' }}
          >
            {polyglot.t('composable_device.model_nr')}:
            <Box fontWeight={'fontWeightBold'} ml={0.4} component={'span'}>
              {merchandiser.machineType.name}
            </Box>
          </Typography>

          <Typography
            variant="h5"
            component="div"
            color={theme.palette.common.black}
          >
            {polyglot.t('composable_device.serial_nr')}:
            <Box fontWeight={'fontWeightBold'} ml={0.4} component={'span'}>
              {merchandiser.composableDevice?.labels?.serial_number}
            </Box>
          </Typography>
        </Box>

        <Box>
          {filteredChannels.map((channel, indexChannel) => (
            <ChannelConnection
              channel={channel}
              merchandiser={merchandiser}
              key={indexChannel}
            ></ChannelConnection>
          ))}
        </Box>
      </Stack>
    </CardContent>
  );
};
